module.exports = __webpack_public_path__ + "assets/Nahrungsergaenzungsmittel_Vitaminmangel.e7dce6e0.png";